// @flow strict

import * as React from 'react'
import cx from 'classnames'
import styles from './Button.module.scss'

/*******************************************************************************
  Types
 ******************************************************************************/

export type OnClickHandler = (SyntheticMouseEvent<*>) => mixed

export type Props = {
  children: React.Node,
  type?: 'submit',
  theme?: 'primary' | 'secondary' | 'tertiary',
  href?: string,
  onClick?: OnClickHandler,
  openInNewTab?: boolean,
  className?: string,
}

export type NewWindowParams = {
  target: string,
  rel: string,
}

/*******************************************************************************
  Component
 ******************************************************************************/

function createNewWindowParams(openInNewTab?: boolean): ?NewWindowParams {
  if (openInNewTab !== undefined) {
    return {
      target: '_blank',
      rel: 'noopener noreferrer',
    }
  }
}

const LinkButton = (props: Props) => {
  const {
    theme = 'primary',
    children,
    href,
    openInNewTab,
    onClick,
    className,
  } = props

  return (
    <a
      href={href}
      className={cx(styles[theme], className)}
      onClick={onClick}
      data-testid="Button"
      {...createNewWindowParams(openInNewTab)}
    >
      {children}
    </a>
  )
}

const Button = (props: Props) => {
  if (props.href !== undefined) return <LinkButton {...props} />

  const { theme = 'primary', children, onClick, type, className } = props

  return (
    <button
      data-testid="Button"
      onClick={onClick}
      className={cx(styles[theme], className)}
      type={type === 'submit' ? type : undefined}
    >
      {children}
    </button>
  )
}

export default Button
